import { render, staticRenderFns } from "./RentServiceFeeDetail.vue?vue&type=template&id=1d52d2bc&scoped=true&"
import script from "./RentServiceFeeDetail.vue?vue&type=script&lang=js&"
export * from "./RentServiceFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./RentServiceFeeDetail.vue?vue&type=style&index=0&id=1d52d2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52d2bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VContainer,VDialog,VProgressCircular})
